import React, { useContext, useEffect, useMemo } from 'react';

// Components
import LandingPageHeader from 'shared/components/LandingPageHeader';
import RegistrationBanner from 'shared/components/LandingPageCTA/RegistrationBanner';
import LandingPageDropdownButton from 'shared/components/LandingPageCTA/LandingPageDropdownButton';
import RegistrationButton from 'shared/components/LandingPageCTA/RegistrationButton';
import ConfirmationPageDetails from 'shared/components/ConfirmationPageDetails';
import ConfirmationBackgroundImage from 'assets/images/webinar-confirmation.svg';

// Utilities
import BravelyData from 'utils/data';
import { mixpanelEvents, mixpanelTrack } from 'utils/mixpanelHelpers';
import { trackGTM } from 'utils/tracker';

// Context
import WebinarsContext from 'webinars/context';

// Styles
import './styles';

// Helpers
import { getPageContent } from './helpers/contentHelpers';
import { isPro } from 'utils/role';

const hasUpcomingSession = BravelyData('hasUpcomingSession');
const employeeEncodedId = BravelyData('identity');
const organization = BravelyData('organization');

const {
  webinars: { VIEW_WEBINAR_CONFIRMATION_PAGE },
} = mixpanelEvents;

const WebinarConfirmationPage = () => {
  const { webinar } = useContext(WebinarsContext);

  const simpleDateTime = useMemo(
    () => webinar.formattedDate.replace(' | ', ' at '),
    []
  );

  const {
    title,
    subTitle,
    buttonProps,
    bookCtaProps,
    shareCtaProps,
  } = useMemo(() => getPageContent(webinar, simpleDateTime));

  const ctaProps = hasUpcomingSession || isPro() ? shareCtaProps : bookCtaProps;

  const { name, encodedId } = webinar;

  useEffect(() => {
    const {
      button: {
        props: { text },
      },
    } = ctaProps || {};

    mixpanelTrack(VIEW_WEBINAR_CONFIRMATION_PAGE, {
      encodedId,
      name,
      CTA: text,
    });

    // Track successful webinar registrations on Google Tag Manager
    trackGTM({
      event: 'Webinar Registration',
      organization: organization,
      encodedId: employeeEncodedId,
      webinarName: name,
    });
  }, []);

  return (
    <div className="webinar-confirmation-container">
      <div className="confirmation-page-header">
        <LandingPageHeader title={title} subTitle={subTitle} />
        <div className="landing-page-banner-wrapper app-centered">
          <RegistrationBanner
            text={webinar.formattedDate}
            buttons={[
              <LandingPageDropdownButton
                key={'register-btn'}
                {...buttonProps}
              />,
            ]}
          />
        </div>
      </div>
      <div className="app-centered confirmation-page-secondary-cta">
        <ConfirmationPageDetails
          ctaProps={ctaProps}
          backgroundImg={ConfirmationBackgroundImage}
        />
      </div>
    </div>
  );
};

export default WebinarConfirmationPage;
